import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import './Header.css';
import { FaPowerOff } from 'react-icons/fa';
import { FaArrowLeft } from 'react-icons/fa';

function Header() {
  const { width } = useWindowDimensions();

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return windowDimensions;
  }
  

  const location = useLocation()
  let history = useHistory();  

  function Loggout(){
    localStorage.clear();
    history.push("/login");
  }

  function back(){
    history.push("/campana");
  }

  
  return (
    <div className='wrap header'>
      {location.pathname.includes("candidato")?
       <button className={"button-small back"} onClick={back}><FaArrowLeft/> Regresar</button>
       :
       <></>
       /*<div style={{ backgroundImage: "url(/iconos/Triangulos.png)"}} className="Triangulo"></div>*/
      }
       <div className='logoContainer'>
      {width<500 && (location.pathname.includes("candidato")||location.pathname.includes("campana"))?( 
          <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo-no" alt="Guadalupana"></img>
        ):(
          <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo" alt="Guadalupana"></img>
        )
      }
      </div>
      { (location.pathname!=='/login' && location.pathname!=='/registro' )?
      <div>
        <button className={"button-small logout"} onClick={Loggout}><FaPowerOff/>  Salir </button>
      </div>:
      <div></div>
      }
  </div>
    
  )
}

export default Header